module.exports = __webpack_public_path__ + "img/rm.3a23ad8e.svg";